






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      const user = JSON.parse(context.root.$route.query.user as string);
      document.cookie = 'access_token=' + user.access_token;
      document.cookie = 'smarky_user_id=' + user.id;
      document.cookie = 'user=' + context.root.$route.query.user as string;

      context.root.$store.commit("setCurrentUser", user);
      context.root.$store.commit("setDigitalPaperEmail", user.email);
      
      context.root.$router.push("/digital_paper_site/sheet_list").catch(err => {});
    });

    return {
      ...toRefs(state),
    }
  }
})
